
import html2canvas from 'html2canvas'
import { reactive, ref } from 'vue'
import { downloadFile, isMacDesktop } from '@/utils/utils'
import { saveImage } from '@/api/api';
import { store } from '@/store';

export default {
    name: "ScreenShot",
    props: {
        code: String
    },
    setup() {
        
        const hiddenIframe = ref<HTMLIFrameElement | null>(null);
        const data = reactive({
            fixedRoute: '',
            screenshotUrl: '',
            // st: new Date(),
            // et: new Date()
        })

        const captureScreenshot = async (code) => {
            try {
                // data.st = new Date();
                data.fixedRoute = `/share_link?code=${code}&p=image`;
                
                const iframe = hiddenIframe.value  as HTMLIFrameElement;
                const previousContent = iframe.contentDocument?.querySelector('.container-mobile');
                if (previousContent) {
                    await processScreenshot(previousContent);
                } else {
                    iframe.src = '';
                    iframe.src = data.fixedRoute;

                    iframe.onload = async () => {
                        const iframeContent = iframe.contentDocument?.querySelector('.container-mobile');
                        if (iframeContent) {
                            await processScreenshot(iframeContent);
                        }
                    };
                }
            } catch (error) {
                console.error('Error capturing screenshot:', error);
            }
        };

        const processScreenshot = async (iframeContent) => {
            const unwantedElements = iframeContent.querySelectorAll('.header, .footer, .url-bar');
            unwantedElements.forEach((el) => (el as HTMLElement).style.display = 'none');

            const canvas = await html2canvas(iframeContent as HTMLElement, {
                logging: false,
                useCORS: true,
                scale: 1.5,
            });

            unwantedElements.forEach((el) => (el as HTMLElement).style.display = 'block');

            data.screenshotUrl = canvas.toDataURL('image/png');
            await shareScreenshot();
        };

        const shareScreenshot = async () => {
            if (!data.screenshotUrl) return;

            try {
                const file = new File([dataURLtoBlob(data.screenshotUrl)], 'share-page.png', { type: 'image/png' });
                const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Opera Mobi|Windows CE|Symbian|Windows Phone|POLARIS|lgtelecom|nokia|SonyEricsson|LG|SAMSUNG|Samsung/i.test(navigator.userAgent);
                if(isMacDesktop()) {
                    saveImage(JSON.stringify({
                    method: "saveImage",
                    ImageData: data.screenshotUrl
                    // data.screenshotUrl
                  }));
                    // await forceDownloadInSafari(file, file.name); // from snippet #1
                    // await tryShare(file)
                } else if (!isMobile) {
                  // PC/Desktop
                  downloadFile(file);
                  setTimeout(()=> {
                      store.dispatch('share/setSaveImage',1)

                  },2500)
                } else {
                  // Mobile (iOS or Android)
                  saveImage(JSON.stringify({
                    method: "saveImage",
                    ImageData: data.screenshotUrl
                    // data.screenshotUrl
                  }));
                }


                // data.et = new Date();
                // console.log('Execution Time:', (data.et.getTime() - data.st.getTime()) / 1000);
            } catch (error) {
                console.error('Error sharing screenshot:', error);
            }
        };

        const dataURLtoBlob = (dataurl: string): Blob => {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)![1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new Blob([u8arr], { type: mime });
        };


        return {
            captureScreenshot,
            data,
            hiddenIframe
        }

    }
}
